import { IViewModifierGroupContext } from './viewModifierGroupContext';

export enum ViewModifierGroupActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	REFETCH_REST_PROPS_DATA = 'REFETCH_REST_PROPS_DATA',
	SET_MODIFIER_GROUP_FULL_INFO = 'SET_MODIFIER_GROUP_FULL_INFO',
	SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS = 'SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS',
	SET_RESTAURANT_PROPS = 'SET_RESTAURANT_PROPS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: ViewModifierGroupActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IViewModifierGroupContext['needRefetchData'];
	};
}

interface IRefetchRestPropsData {
	type: ViewModifierGroupActionTypes.REFETCH_REST_PROPS_DATA;
	payload: {
		needRefetchRestPropsData: IViewModifierGroupContext['needRefetchRestPropsData'];
	};
}

interface ISetModifierGroupFullInfo {
	type: ViewModifierGroupActionTypes.SET_MODIFIER_GROUP_FULL_INFO;
	payload: {
		modifierGroupFullInfo: IViewModifierGroupContext['modifierGroupFullInfo'];
		accessibleRestaurants: IViewModifierGroupContext['accessibleRestaurants'];
	};
}

interface ISetRestaurantIdForRestaurantProps {
	type: ViewModifierGroupActionTypes.SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS;
	payload: {
		restaurantIdForRestaurantProps: IViewModifierGroupContext['restaurantIdForRestaurantProps'];
		restaurantProps: IViewModifierGroupContext['restaurantProps'];
	};
}

interface ISetRestaurantProps {
	type: ViewModifierGroupActionTypes.SET_RESTAURANT_PROPS;
	payload: {
		restaurantProps: IViewModifierGroupContext['restaurantProps'];
	};
}

interface ISetTranslationTab {
	type: ViewModifierGroupActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IViewModifierGroupContext['selectedTranslationTab'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ViewModifierGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IViewModifierGroupContext['typeOfModalWindow'];
	};
}

export type TViewModifierGroupAction =
	| IRefetchData
	| IRefetchRestPropsData
	| ISetModifierGroupFullInfo
	| ISetRestaurantIdForRestaurantProps
	| ISetRestaurantProps
	| ISetTranslationTab
	| IChangeTypeOfModalWindow;
